
<label class="switch">
  <input type="checkbox" [ngModel]="value" [title]="title" (ngModelChange)="onChange($event)">
  <span class="slider round"></span>
</label>
